import { gql } from "@apollo/client";

export const GET_PAYMENT = gql`
  query payment($id: ID!) {
    payment(id: $id) {
      id
      dueDate
      scheduledPaymentDate
      actualPaymentDate
      expenseCategory {
        id
        name
        level
      }
      allocationCode {
        id
        allocationCode
      }
      allocationType {
        key
        name
      }
      payTo {
        id
        firstName
        lastName
        businessName
        email
        contactType
        hasPaymentAccount
      }
      amount
      currency
      receivedFrom {
        id
        name
        email
        type
      }
      description
      createdBy {
        id
      }
      paymentMethod
      status
      transaction {
        id
        amount
        type
        card {
          type
        }
      }
      workflowRequest {
        id
        status
        approvalType
        approvedBy {
          userId
          userName
          role
        }
        approvedDate
        rejectedBy {
          userId
          userName
          role
        }
        canceledBy {
          userId
          userName
          role
        }
        canceledDate
        rejectedDate
        remainingApprovalRoles
        userId
        isApprovalAllowed
      }
      customFields {
        fieldSettingId
        values
      }
    }
  }
`;

export const GET_PAYMENTS = gql`
  query payments(
    $status: [PaymentStatusEnum]
    $searchTerm: String
    $first: Int
    $after: String
    $sortDirection: SortDirectionEnum
    $contactId: String
    $startDate: Float
    $endDate: Float
    $paymentMethod: [PaymentMethodEnum]
  ) {
    payments(
      status: $status
      searchTerm: $searchTerm
      first: $first
      after: $after
      sortDirection: $sortDirection
      contactId: $contactId
      startDate: $startDate
      endDate: $endDate
      paymentMethod: $paymentMethod
    ) {
      edges {
        node {
          id
          dueDate
          scheduledPaymentDate
          actualPaymentDate
          payTo {
            id
            firstName
            lastName
            businessName
            email
            contactType
            hasPaymentAccount
          }
          amount
          currency
          receivedFrom {
            id
            type
            name
            email
          }
          description
          createdBy {
            id
          }
          paymentMethod
          status
          workflowRequest {
            status
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

export const SAVE_PAYMENT = gql`
  mutation savePayment($id: ID!, $input: SavePaymentInput!) {
    savePayment(id: $id, input: $input) {
      id
      status
      errorMessage
    }
  }
`;

export const UPDATE_PAYMENT_DETAILS = gql`
  mutation updatePaymentDetails($id: ID!, $input: UpdatePaymentDetailsInput!) {
    updatePaymentDetails(id: $id, input: $input) {
      id
      status
      errorMessage
    }
  }
`;

export const APPROVE_PAYMENT = gql`
  mutation approvePayment($requestId: ID!) {
    approvePayment(requestId: $requestId) {
      id
      status
      errorMessage
    }
  }
`;

export const REJECT_PAYMENT = gql`
  mutation rejectPayment($requestId: ID!) {
    rejectPayment(requestId: $requestId)
  }
`;

export const CANCEL_PAYMENT = gql`
  mutation cancelPayment($id: ID!) {
    cancelPayment(id: $id)
  }
`;

export const MARK_AS_PAID = gql`
  mutation markAsPaid($id: ID!, $actualPaymentDate: Float!) {
    markAsPaid(id: $id, actualPaymentDate: $actualPaymentDate)
  }
`;
